module.exports = __webpack_public_path__ + "build/desktop/img/logo-max.4f7f56aca33de328ac00e5bdb0b01fc9.svg";